import React from 'react';

import css from './EditIcon.module.scss';

type EditIconProps = {
    onEdit: () => void;
    icon?: string;
    customBtnClass?: string;
};

const EditIcon = ({ onEdit, icon, customBtnClass }: EditIconProps) => {
    return (
        <button
            className={customBtnClass ? `${customBtnClass} ${css.container}` : `${css.container}`}
            onClick={() => onEdit()}
        >
            <img
                className={css.container__img}
                src={icon || '/front-static/icons/action/edit-brand-primary.svg'}
                alt="edit"
            />
        </button>
    );
};

export default EditIcon;
